// extracted by mini-css-extract-plugin
export default {"root":"_shV39BnkDWR6Rvv6ZUH","expandable":"kpMSHnCnYecyOqavrhFv","content":"aePPJPUmnklcnS9gPrlK","placeHolderShimmer":"VnUpBo_hW9ljcIlm4TYP"};